import React from 'react';

import TrackersList from '@/features/trackers/components/TrackersList';
import TitleHelmet from '@/components/TitleHelmet';

import { withAuthenticationRequired } from '@auth0/auth0-react';
import styles from './trackers.module.scss';

const Trackers: React.FC = () => {
  return (
    <React.Fragment>
      <TitleHelmet title="Trackers" />
      <TrackersList />
    </React.Fragment>)
};

export default withAuthenticationRequired(Trackers);
